<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X4Phxb/tc-custom/9780545630993.jpg?1701232720738" alt="This image is the cover for the book Trick or Trap, Goosebumps Most Wanted"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trick or Trap, Goosebumps Most Wanted
      </h1>
      <p class="bookDescription body article font2">
        <b> In this spinoff to the <i>New York Times</i>–bestselling Goosebumps series, best friends enter a haunted house and a spirit tries to keep them there forever.</b><br/><br/>Scott Harmon would be the kid who is most afraid of everything at his school. That is, if it wasn’t for his best friend, Amanda Gold, who is just as easily terrified. They really don’t have it easy. Scott’s younger sister spends all of her time trying to frighten them. She’ll do whatever it takes to get them to scream. Scott and Amanda are also tormented by some neighborhood kids. But this Halloween, Scott and Amanda are determined to conquer their fears, even if that means spending time in the creepy old house that everyone else says is haunted. And if Scott and Amanda can stop being so afraid, maybe they can even finally get some revenge. Unless the house really is haunted . . . <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.L. Stine
      </h2>
      
      <p class="authorDescription body article"> R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, <I>The Little Shop of Monsters</I> and <I>Mary McScary</I>. R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8259b2b6